import React, { Component } from 'react';
import { GenericInputValidate, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

class InputBonus extends Component {
    constructor(props) {
        super(props);
        this.changeInput = this.changeInput.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("BONIFICACION_ALTA", event.target.value)
    }

    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;

        let errorContainer;

        errorContainer = <label className="error">
            {(errors = getFieldError('inputBonus')) ?
                this.props.form.isFieldTouched("inputBonus") ?
                    errors.join(',') : null
                : null}</label>

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-5">
                            <label className="label-primary">Bonificación del alta</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-1">
                            <GenericInputValidate
                                getFieldProps={getFieldProps('inputBonus', {
                                    onChange(e) {
                                        me.changeInput(e);
                                    },
                                    rules: [{
                                        required: true,
                                        pattern: /^([1-9]?\d|100)$/,
                                        message: 'Debe ingresar un valor válido.'
                                    }]
                                })}
                                id="inputBonus"
                                name="inputBonus"
                                value={this.props.data.BonificacionAlta}
                                className="form-control default-input"
                                maxLength="3"
                            />
                        </div>
                        <div className="col-xs-11">
                            <p>%</p>
                            {errorContainer}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default InputBonus;